import { useMemo, useEffect, useState } from 'react';
import { parsePolygonWHoles } from '../../../shared/geo-map/lib';
// eslint-disable-next-line
import { useGeoZonesInBatches } from '../../geoZones/hooks/useGeoZonesInBatches';
import { getUniqueGeozoneIds } from '../utils/geozoneUtils';

export const useVehicleHistoryGeoZones = (coords) => {
  const [geoZones, setGeoZones] = useState([]);
  const [isSearchGeozoneActive, setIsSearchGeozoneActive] = useState(false);

  const uniqueGeozoneIds = useMemo(() => getUniqueGeozoneIds(coords), [coords]);
  const rawGeozones = useGeoZonesInBatches(uniqueGeozoneIds, 50);

  useEffect(() => {
    const preparingGeozones = rawGeozones?.map((geozone) => ({
      ...geozone,
      polygon: parsePolygonWHoles(geozone.area),
    }));

    if (preparingGeozones && preparingGeozones.length) {
      setGeoZones(preparingGeozones);
    }
  }, [rawGeozones]);

  return {
    geoZones,
    setGeoZones,
    isSearchGeozoneActive,
    setIsSearchGeozoneActive,
  };
};

export default useVehicleHistoryGeoZones;
